<template>
  <div class="event-con-list">
      <a href="#" @click.prevent="goMoviePage()" class="event-con-list-anchor">
        <span class="vod-img">
          <img :src="'http://' + eventContentData.image" :alt="eventContentData.title + '포스터'"/>
          <!--우측상단 -->
          <span class="tag-right">
            <span class="event-tag-age">
              <AgeAdultOnlyIcon v-if="+eventContentData.targetage >= 18" />
            </span>
          </span>
        </span>
        <span class="event-con-desc-wrap">
          <strong v-if="eventContentData.title" class="event-con-tit">{{ eventContentData.title }}</strong>
          <table>
            <tr class="event-con-desc" v-if="eventContentData.directors && eventContentData.directors.list">
              <th><span class="event-desc-strong">감독</span></th>
              <td><span class="event-desc-detail">
                <template v-for="(director, directorIndex) in eventContentData.directors.list">{{ director }}
                  <template v-if="eventContentData.directors.list.length > directorIndex + 1">, </template>
                </template>
              </span></td>
            </tr>
            <tr class="event-con-desc event-desc-actor" v-if="eventContentData.actors && eventContentData.actors.list">
              <th><span class="event-desc-strong">출연</span></th>
              <td><span class="event-desc-detail">
                <template v-for="(actor, actorIndex) in eventContentData.actors.list"> {{ actor }}
                  <template v-if="eventContentData.actors.list.length > actorIndex + 1">, </template>
                </template>
              </span></td>
            </tr>
            <tr class="event-con-desc" v-if="eventContentData.genre && eventContentData.genre.list">
              <th><span class="event-desc-strong">장르</span></th>
              <td><span class="event-desc-detail">
              <template v-for="(genre, genreIndex) in eventContentData.genre.list">{{ genre.value }}
                <template v-if="eventContentData.genre.list.length > genreIndex + 1">, </template>
              </template>
            </span></td>
            </tr>
            <tr class="event-con-desc" v-if="eventContentData.releasedate">
              <th><span class="event-desc-strong">개봉일</span></th>
              <td><span class="event-desc-detail">{{ eventContentData.releasedate }}</span></td>
            </tr>
            <tr class="event-con-desc event-synopsis" v-if="eventContentData.synopsis">
              <th><span class="event-desc-strong">줄거리</span></th>
              <td><span class="event-desc-detail" v-html="eventContentData.synopsis"></span></td>
            </tr>
          </table>
        </span>
      </a>
  </div>
</template>

<script>
import AgeAdultOnlyIcon from '@/assets/svg/common/tags/age/ic_tag_6_5.svg'
import utils from '@/common/util/utils'

export default {
  name: 'EventContent',
  components: {
    AgeAdultOnlyIcon
  },
  data () {
    return {
      device: utils.cookies.getDevice()
    }
  },
  props: {
    eventContentData: {
      type: Object
    }
  },
  methods: {
    goMoviePage () {
      if (this.device === 'mobile') {
        this.$router.push(`/player/movie?movieid=${this.eventContentData.movieid}`)
      } else {
        location.href = 'captvpooq://player/movie?movieid=' + this.eventContentData.movieid
      }
    }
  }
}
</script>
<style scoped>
  h1, h2, h3, h4, h5, h6, strong {
    font-weight: 400;
  }
  .tag-age{
    position: absolute;
    top: 5px;
    left: 5px;
  }
  .event-con-list {
    position: relative;
    width: 100%;
    height: auto;
    display: block;
    padding: 20px 0;
    border-bottom: 1px solid #2f2f2f;
  }
  .event-con-list-anchor {
    display: flex;
    flex-direction: row;
  }
  .event-con-list .vod-img {
    width: 85px;
  }
  .vod-img,
  .vod-img img {
    overflow: hidden;
    border-radius: 8px;
  }
  .vod-img {
    position: relative;
    display: block;
    width: 85px;
  }
  .vod-img img{
    width: 100%;
  }
  .event-con-desc-wrap {
    flex: 1;
    margin-left: 15px;
    display: flex;
    flex-direction: column;
  }
  .event-con-desc-wrap table{
    width: 100%;
    table-layout: fixed;
  }
  .event-con-desc{
    position: relative;
    display: block;
    color: #717171;
  }
  .event-con-tit{
    margin-bottom: 5px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    word-wrap: break-word;
    font-size: 13px;
    line-height: 18px;
    color: #fff;
  }
  .event-desc-strong,
  .event-desc-detail{
    font-size: 13px;
    line-height: 1.38em;
  }
  .event-desc-strong{
    display: inline-block;
    min-width: 24px;
    margin-right: 15px;
    font-weight: 400;
    color: #a5a5a5;
  }
  .event-desc-detail{
    color: #a5a5a5;
  }
  .event-desc-actor th {
    vertical-align: top;
  }
  .event-desc-actor td{
    margin-left: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    word-wrap: break-word;
    -webkit-line-clamp: 1;
  }
  .event-synopsis td{
    display: block;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    word-wrap: break-word;
    -webkit-line-clamp: 5;
    margin-left: 0;
  }
  .event-tag-age{
    position: absolute;
    top: 5px;
    right: 5px;
  }
</style>
